import { gql } from 'graphql-request';

const SingInQuery = gql`
  query SingIn($username: String!, $password: String!, $isAccount: Boolean!) {
  SingIn(username: $username, password: $password, isAccount: $isAccount) 
}
`;
export default SingInQuery;
